import config from './custom/tailwind.config.mjs';
export default config;
